import { Field, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

import { getSharedProperty } from '../../../../getters';
import { useHeaderNavigation } from './useHeaderNavigation';

interface HeaderConfig {
  logo?: ImageField | null;
  showNavigation?: Field<boolean> | null;
  isNavigationTransparent?: Field<boolean> | null;
}

export const useHeaderConfig = (): HeaderConfig => {
  const { route } = useHeaderNavigation();

  const fields = route?.fields as unknown as {
    OpenGraphImage: ImageField;
    ShowNavigation: Field<boolean>;
    TransparentNavigation: Field<boolean>;
  };

  const logo = getSharedProperty(fields, 'OpenGraphImage');
  const showNavigation = getSharedProperty(fields, 'ShowNavigation');
  const isNavigationTransparent = getSharedProperty(fields, 'TransparentNavigation');

  return {
    logo,
    showNavigation,
    isNavigationTransparent,
  };
};
